import { render, staticRenderFns } from "./ConfigSnapshotCard.vue?vue&type=template&id=50b70ebe&scoped=true&"
import script from "./ConfigSnapshotCard.vue?vue&type=script&lang=js&"
export * from "./ConfigSnapshotCard.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSnapshotCard.vue?vue&type=style&index=0&id=50b70ebe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b70ebe",
  null
  
)

export default component.exports